const str = x => (x == null ? '' : x);

export const fullName = ({lastName, firstName}) => `${str(lastName)} ${str(firstName)}`;
